/* eslint-disable react/require-default-props, jsx-a11y/label-has-associated-control */

import React from 'react';
import SubtitleRegular from 'components/Typography/SubtitleRegular';

import type { ComponentProps } from 'react';

import './index.scss';

type RadioButtonProps = ComponentProps<'input'> & {
  label?: string;
};

export default function RadioButton({
  label = '',
  disabled = false,
  className = '',
  ...otherProps
}: RadioButtonProps) {
  return (
    <label className={`ds-radio-container ${className} ${disabled ? 'disabled' : ''}`}>
      <input
        type="radio"
        disabled={disabled}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...otherProps}
      />
      <span className="checkmark" />
      <SubtitleRegular>{label}</SubtitleRegular>
    </label>
  );
}
